import request from '@/router/axios'

export const getList = (params) => request({
  url: '/api/produce/env-monitor/alarm/selectPage',
  method: 'post',
  data: params
})

export const handleAlarm = (data) => request({
  url: '/api/produce/env-monitor/alarm/handle',
  method: 'post',
  data
})
